import { DeleteSmall, MoreSettings, OutlinedEdit } from '@shared/assets/icons/components';
import { Flex, Popover } from 'antd';
import type { FC } from 'react';
import styles from './settings.module.scss';
import { useTranslation } from 'react-i18next';
import { Text } from '@shared/ui/antd';
import { useState } from 'react';

interface SettingsProps {
  onUpdate: () => void;
  onDelete: () => void;
}

export const Settings: FC<SettingsProps> = ({ onUpdate, onDelete }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'team.table.settings' });
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleClick = (action: () => void) => {
    return (e: React.MouseEvent) => {
      e.stopPropagation();
      setOpen(false);
      action();
    };
  };

  const icons = [
    {
      icon: <OutlinedEdit />,
      title: t('update'),
      onClick: onUpdate,
    },
    {
      icon: <DeleteSmall />,
      title: t('remove'),
      onClick: onDelete,
    },
  ];

  const menu = (
    <Flex vertical>
      {icons.map((item, index) => (
        <Flex
          key={index}
          align="center"
          justify="start"
          className={styles.root}
          onClick={handleClick(item.onClick)}
          gap="8px"
        >
          {item.icon}
          <Text variant="sm" fontWeight={600}>
            {item.title}
          </Text>
        </Flex>
      ))}
    </Flex>
  );

  return (
    <Popover
      content={menu}
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
      arrow={false}
      placement="bottomRight"
    >
      <Flex
        justify="center"
        onClick={(e) => e.stopPropagation()}
        align="center"
        className={styles.container}
      >
        <MoreSettings />
      </Flex>
    </Popover>
  );
};
